import axios from "axios";

const api = {
  getRenungan: () =>
    axios.get(
      `https://www.santapanrohani.org/wp-json/wp/v2/posts?before=${new Date().toISOString()}&per_page=1`
    )
};

const coverImage = date =>
  `https://d626yq9e83zk1.cloudfront.net/files/${date.getFullYear()}/${String(
    date.getMonth() + 1
  ).padStart(2, 0)}/odb${date.getFullYear()}${String(
    date.getMonth() + 1
  ).padStart(2, 0)}${String(date.getDate()).padStart(2, 0)}.jpg`;

export default {
  getRenungan: ({ commit }) => {
    commit("startGettingRenungan");
    api.getRenungan().then(response => {
      commit("setRenungan", {
        ...response.data[0],
        coverImage: coverImage(new Date())
      });
    });
  }
};
